import { Box, Button, debounce, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material"
import { useAppSelector } from "../../../../../../../hooks/store-hooks"
import { useListaDeduplicacaoService } from "../../../../../../../../use-cases/geo-veles"

export const CreateListaDeduplicacaoForm = (props: {
    openForm: boolean
}) => {
    // State
    const { listaDeduplicacao } = useAppSelector((state) => state)
    // Hook
    const {
        openCreateListaDeduplicacaoForm,
        setCreateListaDeduplicacaoName,
        createListaDeduplicacao
    } = useListaDeduplicacaoService()

    return (
        <>
            {
                props.openForm === true &&
                <Dialog
                    fullWidth
                    maxWidth="md"
                    open={listaDeduplicacao.openCreateListaDeduplicacao}
                    onClose={() => {
                        openCreateListaDeduplicacaoForm(false)
                    }}
                >
                    <DialogTitle>
                        Criar nova lista de deduplicação
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Escolha um nome para a sua lista
                        </DialogContentText>
                        <Box my={3}>
                            <TextField
                                error={Boolean(listaDeduplicacao.createListaDeduplicacaoForm.touched && listaDeduplicacao.createListaDeduplicacaoForm.errors.find(item => item.key === 'Nome'))}
                                helperText={listaDeduplicacao.createListaDeduplicacaoForm.errors.find((error) => error.key === 'Nome')?.message}
                                defaultValue={listaDeduplicacao.createListaDeduplicacaoForm.fields.Nome}
                                onChange={debounce((e) => {
                                    setCreateListaDeduplicacaoName(e.target.value)
                                }, 500)}
                                autoFocus
                                id="nomeproj"
                                label="Digite o nome da lista"
                                fullWidth
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                openCreateListaDeduplicacaoForm(false)
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={() => {
                                createListaDeduplicacao()
                            }}
                        >
                            Criar
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
}